module.exports = __webpack_public_path__ + "img/gtzy1_zhCn.2139d94b.png";